import {AdminApi} from "./AdminApi";
import {Brand} from "@unleashed/models/Brand";

const AdminBrandsApi = AdminApi.injectEndpoints({
  endpoints: (builder) => ({
    getBrands: builder.query<Brand[], void>({
      query: () => {
        return {
          url: "brands",
          method: "GET"
        };
      },
      keepUnusedDataFor: 86400,
      providesTags: [{type: "Brands", id: "LIST"}],
    }),
  }),
});

export const {
  useGetBrandsQuery,
} = AdminBrandsApi;
